module.exports = __webpack_public_path__ + "assets/building-wall-icon.16d99f7e.svg";